import React from 'react';
import { useInView } from '../hooks/useInView';
const chapters = [{
  number: '01',
  title: 'Tus Derechos Constitucionales',
  description: 'Lo que ICE no puede hacer, incluso sin papeles.'
}, {
  number: '02',
  title: 'El Plan Familiar de Emergencia',
  description: 'Cómo preparar a tu familia para lo inesperado.'
}, {
  number: '03',
  title: 'Si Tocan Tu Puerta',
  description: 'Paso a paso: qué decir y qué NO decir.'
}, {
  number: '04',
  title: 'Poder Legal y Custodia',
  description: 'Protege a tus hijos con documentos legales.'
}, {
  number: '05',
  title: 'Recursos Legales Gratuitos',
  description: 'Organizaciones que te ayudan sin cobrar.'
}, {
  number: '06',
  title: 'Salud Mental y Resiliencia',
  description: 'Cuidar tu bienestar emocional en tiempos difíciles.'
}];
export function ChapterList() {
  const [headerRef, headerInView] = useInView();
  const [gridRef, gridInView] = useInView();
  return <section className="py-16 bg-[#1a56a0] text-white border-t border-white/10" data-id="element-23">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-24">
        <div ref={headerRef} className={`text-center mb-16 animate-on-scroll ${headerInView ? 'in-view' : ''}`} data-id="element-25">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4 uppercase tracking-wide" data-id="element-26">
            Qué Vas a Aprender
          </h2>
          <p className="text-white/70 font-sans text-lg max-w-2xl mx-auto" data-id="element-27">
            Una guía completa para proteger lo que más importa
          </p>
          <div className="w-24 h-1 bg-[#c0392b] mx-auto mt-8" data-id="element-28" />
        </div>

        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-12" data-id="element-29">
          {chapters.map((chapter, index) => <div key={index} className={`group flex items-center bg-white/10 rounded-lg p-5 hover:bg-white/15 transition-all duration-300 ${index % 2 === 0 ? 'animate-slide-left' : 'animate-slide-right'} delay-${index % 6} ${gridInView ? 'in-view' : ''}`} data-id="element-30">
              <span className="font-sans text-sm font-bold bg-white text-[#c0392b] w-9 h-9 flex items-center justify-center rounded-full mr-5 flex-shrink-0 shadow-sm" data-id="element-31">
                {chapter.number}
              </span>
              <div data-id="element-32">
                <h3 className="font-sans font-bold text-lg text-white mb-0.5 group-hover:text-[#c0392b] transition-colors duration-300" data-id="element-33">
                  {chapter.title}
                </h3>
                <p className="font-sans text-sm text-white/60 leading-snug" data-id="element-34">
                  {chapter.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}